import { MODERATOR_PASS_KIND } from '@/constant/passes';

import { PersonPass } from '@/types/person';

export const isModerator = (passes: PersonPass[]) =>
	passes?.some((pass) => pass.pass_type.kind === MODERATOR_PASS_KIND);
